import React from 'react';
import { Button } from './Button';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-id="element-446">
      <div className="h-16 w-16 bg-gray-50 rounded-full flex items-center justify-center mb-4" data-id="element-447">
        <Icon className="h-8 w-8 text-gray-400" data-id="element-448" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-449">{title}</h3>
      <p className="text-gray-500 max-w-sm mb-6" data-id="element-450">{description}</p>
      {actionLabel && onAction && <Button onClick={onAction} variant="secondary" data-id="element-451">
          {actionLabel}
        </Button>}
    </div>;
}